import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../../common/GridLayout";
import { FillFilters, getAppSettings, loadLookupFromStaticDataSource } from '../../../../common/Utils';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Lookup,
} from "devextreme-react/data-grid";
import { SearchLayout } from './Layout';
import {
    storageStartDateOptions,
    restartStorageDatesOptions,
    expDateBasedOnOptions,
    rateScheduleFilterOptions,
} from './options';
import { ItemDataProfileRoutes } from '../../../../const/constants';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import '../../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    // Honor the "Collapse Filter Panel" application setting: collapsed -> no item selected,
    // expanded -> the first (and only) search-filter panel is selected.
    const filtersCollapsed = !!getAppSettings()?.FiltersCollapsed;
    const [selectedItems, setSelectedItems] = useState(filtersCollapsed ? [] : [searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000];
    const gridKey = "C41A7E28-9D65-4B03-8F17-2E6B5A9C3D80";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    // One key per SearchLayout field, hidden ones included: FillFilters only ever sees what is in
    // formFields, so a field the dynamic-form customiser un-hides has to already have a key here or
    // it would silently never filter - and Reset has to be able to clear it.
    const initialFormFields = {
        recordNumber: '',
        profileCode: '',
        description: '',
        addToExpDate: '',
        storageStartDate: '',
        restartStorageDates: '',
        expDateBasedOn: '',
        rateScheduleFilter: '',
        popupMessage: '',
        userDefinedCode1: '',
        userDefinedCode2: '',
        userDefinedCode3: '',
        userDefinedCode4: '',
        userDefinedCode5: ''
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const formFieldsRef = useRef(formFields);
    const [resultData, setResultData] = useState(null);

    useEffect(() => {
        formFieldsRef.current = formFields;
    }, [formFields]);

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length === 1) {
            rowId.current = selectedRowsData[0].RowId;
            setIsEditButtonDisabled(false);
        } else {
            rowId.current = null;
            setIsEditButtonDisabled(true);
        }
    };

    const handleEditClick = () => {
        history.push(`${ItemDataProfileRoutes.Edit}?rowid=${rowId.current}`);
    };

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource();

        // FillFilters emits ["<field>", "contains", value] for every populated field. Add Days maps to
        // a decimal column, and DataSourceLoader compiles "contains" to String.Contains - which throws
        // on a non-string accessor. So that one field is filtered separately, as an equality match.
        const { addToExpDate, ...textFields } = formFields;
        const filters = FillFilters(textFields);

        const addDays = Number(addToExpDate);
        if (addToExpDate !== '' && addToExpDate !== null && addToExpDate !== undefined && !isNaN(addDays)) {
            if (filters.length > 0) {
                filters.push("and");
            }
            filters.push(["addToExpDate", "=", addDays]);
        }

        datasource.filter(filters.length === 0 ? null : filters);
        setResultData(datasource);
    };

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setTimeout(() => {
            setResultData(loadDatasource());
        }, 100);
    };

    const handleFormLoad = useCallback(() => {
        setTimeout(() => {
            loadLookupFromStaticDataSource("storageStartDate", storageStartDateOptions, null, formRefs, 'id', 'text');
            loadLookupFromStaticDataSource("restartStorageDates", restartStorageDatesOptions, null, formRefs, 'id', 'text');
            loadLookupFromStaticDataSource("expDateBasedOn", expDateBasedOnOptions, null, formRefs, 'id', 'text');
            loadLookupFromStaticDataSource("rateScheduleFilter", rateScheduleFilterOptions, null, formRefs, 'id', 'text');
        }, 100);
    }, []);

    const handleFieldChange = useCallback((name, value) => {
    }, []);

    const loadDatasource = () => {
        let store = createStore({
            key: 'RowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.ItemDataProfile.GetItemDataProfiles}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    useEffect(() => {
        if (!resultData) {
            setResultData(loadDatasource());
        }
    }, []);

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Item Data Profiles
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='7B2E5F14-8A39-4C60-9D7B-1F4A6C8E2B53'
                                layoutName='WMItemDataProfileSearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode="multiple" />
                        <Sorting visible={true} mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button
                                    disabled={isEditButtonDisabled}
                                    onClick={handleEditClick}
                                    type="default"
                                    text="Edit"
                                ></Button>
                            </GridToolbarItem>
                            <GridToolbarItem location="before">
                                <div>
                                    <Link to={ItemDataProfileRoutes.Create}>
                                        <Button
                                            type="default"
                                            className="gridTopButton"
                                            text="Create"
                                        ></Button>
                                    </Link>
                                </div>
                            </GridToolbarItem>
                            <GridToolbarItem location="after">
                                <GridLayoutManager
                                    gridKey={gridKey}
                                    dataGrid={dataGrid}
                                    currentLayout={currentLayout}
                                    setCurrentLayout={setCurrentLayout}
                                    accessToken={accessToken}
                                />
                            </GridToolbarItem>
                            <GridToolbarItem name="columnChooserButton" />
                            <GridToolbarItem name="exportButton" />
                        </GridToolbar>

                        {/* Columns are the Delphi fields with VisibleOnGrid = True (uWMM0003.dfm),
                            plus Record #. Coded fields render their descriptions, never the raw code. */}
                        <Column dataType="string" caption="Record #" dataField="RecordNumber" />
                        <Column dataType="string" caption="Profile" dataField="ProfileCode" />
                        <Column dataType="string" caption="Description" dataField="Description" />
                        <Column dataType="string" caption="Start Date" dataField="StorageStartDate">
                            <Lookup dataSource={storageStartDateOptions} displayExpr="text" valueExpr="id" />
                        </Column>
                        <Column dataType="string" caption="Restart Dates" dataField="RestartStorageDates">
                            <Lookup dataSource={restartStorageDatesOptions} displayExpr="text" valueExpr="id" />
                        </Column>
                        <Column dataType="string" caption="Based on" dataField="ExpDateBasedOn">
                            <Lookup dataSource={expDateBasedOnOptions} displayExpr="text" valueExpr="id" />
                        </Column>
                        <Column dataType="number" caption="Add Days" dataField="AddToExpDate" format="#0" />
                        <Column dataType="string" caption="Rate Sch Filter" dataField="RateScheduleFilter">
                            <Lookup dataSource={rateScheduleFilterOptions} displayExpr="text" valueExpr="id" />
                        </Column>
                        <Column dataType="string" caption="Popup Msg" dataField="PopupMessage" visible={false} />
                        <Column dataType="string" caption="Code 1" dataField="UserDefinedCode1" visible={false} />
                        <Column dataType="string" caption="Code 2" dataField="UserDefinedCode2" visible={false} />
                        <Column dataType="string" caption="Code 3" dataField="UserDefinedCode3" visible={false} />
                        <Column dataType="string" caption="Code 4" dataField="UserDefinedCode4" visible={false} />
                        <Column dataType="string" caption="Code 5" dataField="UserDefinedCode5" visible={false} />
                        {/* Technical columns stay hidden - users never see raw ids. */}
                        <Column dataType="string" caption="RowId" dataField="RowId" visible={false} showInColumnChooser={false} />
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(List);
